import {
  Lci3Report,
  Lci3SalesMetrics,
} from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { SalesHighlights, VisitHighlights } from '../../../Highlights';

type HighlightsProps = {
  campaignName: string;
  selectedReport: Lci3Report;
  salesMetrics: Lci3SalesMetrics | null;
};

export const Highlights = (props: HighlightsProps) => {
  return props.salesMetrics ? (
    <SalesHighlights
      campaignName={props.campaignName}
      salesMetrics={props.salesMetrics}
      uniqueUsers={props.selectedReport.visitMetrics.uniqueUsers}
    />
  ) : (
    <VisitHighlights
      campaignName={props.campaignName}
      report={props.selectedReport}
    />
  );
};
